import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__slug-generate-input';
export class GenerateSlug {
    static init($root = $('body')) {
        let timeout;
        $(ELEMENT_SELECTOR).on('input', event => {
            clearTimeout(timeout);
            const $element = $(event.currentTarget);
            timeout = setTimeout(() => {
                this.updateSlug($element);
            }, 1000);
        });
    }
    static updateSlug($element) {
        const { url, slugInput } = $element.data();
        const $slugInput = $(slugInput);
        const $slugField = $slugInput.parents('.field');
        const data = {
            name: $element.val(),
        };
        if ($slugInput.attr('readonly') === 'readonly' || $element.val() === '') {
            return;
        }
        $.ajax({
            type: 'GET',
            url,
            data,
            dataType: 'json',
            beforeSend: () => {
                $slugField.addClass('ui form loading');
            },
        })
            .done(response => {
            $slugInput.val(response.slug);
            if ($slugField.hasClass('error')) {
                $slugField.removeClass('error');
                $slugField.find('.sylius-validation-error').remove();
            }
        })
            .always(() => {
            $slugField.removeClass('loading');
        });
    }
}
